import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaSignOutAlt,
  FaCalendarAlt,
  FaCalendarCheck,
  FaBed
} from "react-icons/fa";

const Sidebar = ({ user, titre }) => {


  const [openToursSubmenu, setOpenToursSubmenu] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);
  const user_id = localStorage.getItem('userId');
  const groupe_id = localStorage.getItem('groupe_id');
  const [accesGroupe, setAccesGroupe] = useState(() => {
    // Initialiser avec les accès stockés dans localStorage si disponibles
    const storedAccess = localStorage.getItem('accesGroupe');
    return storedAccess ? JSON.parse(storedAccess) : [];
  });

  const activeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    borderLeft: '4px solid white',
  };

  const defaultStyle = {
    backgroundColor: 'transparent',
    borderLeft: 'none',
  };

  const sidebarStyle = {
    // background: 'linear-gradient(to bottom, #273748, #28416F)',
    // color: 'white',
    // height: 'auto',
    background: 'linear-gradient(to bottom, #273748, #28416F)',
    color: 'white',
    // height: '100vh',
    // position: 'fixed',
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem("accesGroupe");
    localStorage.removeItem("token");
    window.location.replace('/');
  };

  return (
    <nav className="navbar-default navbar-static-side" role="navigation" style={sidebarStyle}>
      <div className="sidebar-collapse">
        <div className="" style={{ marginBottom: '100px', width: 'auto' }}>
          <ul className="nav metismenu" id="side-menu">
            {/* Logo & Nom de l'application */}
            <li className="nav-header" style={{ marginBottom: '0', padding: '10px 0' }}>
              <div className="profile-element ml-4">
                <span className="font-bold text-white"><h2>O'MEL Services</h2></span>
              </div>
            </li>


            <li className={
              isActive('/Calendrier')
                ? 'active' : ''} title="Calendrier">
              <Link className='text-white' to={{
                pathname: `/Calendrier`,
                state: { user, titre }
              }}>
                <FaCalendarAlt /> <span className="nav-label ml-2">Calendrier</span>
              </Link>
            </li>

            {/* Enrôlement */}
            <li className={
              isActive('/liste-reservations')
                ? 'active' : ''}
              title="Réservations">
              <Link className='text-white' to="/liste-reservations">
                <FaCalendarCheck /> <span className="nav-label ml-2">Réservations</span>
              </Link>
            </li>

            {/* Suivi document */}
            <li className={
              isActive('/liste-chambres')
                ? 'active' : ''}
              title="Chambres">
              <Link className='text-white' to="/liste-chambres">
                <FaBed /> <span className="nav-label ml-2">Chambres</span>
              </Link>
            </li>

            {/* Déconnexion */}
            <li className='ml-2' style={defaultStyle} title="Déconnexion">
              <Link onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', width: '100%', textAlign: 'left', padding: '10px 15px' }}>
                <FaSignOutAlt /> <span className="nav-label ml-2">Déconnexion</span>
              </Link>
            </li>
          </ul>
        </div>


      </div>
    </nav>
  );
};

export default Sidebar;